export default {
  device: {
    checkLoading: '検出中....',
    check: 'けんしゅつ',
    checkTitle: 'デバイス検出',
    checkResult: '検出結果',
    checkItem: '検査項目',
    checkSuccess: '正常に検出されました'
  },
  hybird: {
    id: 'ID',
    status: 'ステータス',
    userName: 'ユーザー名',
    companyName: '会社名',
    companyId: '会社id',
    activeCode: 'アクティブコード',
    createdTime: '作成時間',
    searchPlaceholder: 'ユーザー名または会社名を入力してください',
    active: 'アクティブ化済み',
    unActive: '非アクティブ'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/languages/ja/v6.js